export default __webpack_public_path__ + "static/media/Paymob.b7695da7.png";